import { useFeatures } from '@nextiva/feature-toggle';

export const useFeatureFlagState = (featureFlags) => {
  const { isFeatureEnable, isFeatureReady } = useFeatures();

  return featureFlags.reduce((state, flagName) => {
    state[flagName] = {
      isEnabled: isFeatureEnable(flagName),
      isReady: isFeatureReady(flagName),
    };
    return state;
  }, {});
};
